import { useCallback, useEffect, useRef } from 'react'
import { initSocket, getSocket, disconnectSocket } from '../utils/socket'

export const useSocket = () => {
  const isConnected = useRef(false)

  const connectSocket = useCallback((businessId) => {
    if (!isConnected.current) {
      initSocket()
      const socket = getSocket()
      if (socket) {
        // 在商家登录成功后
        socket.emit('business_connected', businessId)
        console.log('business_connected', businessId)
        isConnected.current = true
      }
    }
  }, [])

  useEffect(() => {
    return () => {
      if (isConnected.current) {
        disconnectSocket()
        isConnected.current = false
      }
    }
  }, [])

  return {
    connectSocket,
    disconnectSocket
  }
}

export const useSocketMessage = (callback) => {
  useEffect(() => {
    const socket = getSocket()
    if (socket) {
      // 监听商家通知
      socket.on('business_notification', (notification) => {
        // 处理接收到的通知，例如显示在界面上
        console.log('接收到新的商家消息', notification)
        callback(notification)
      })
    }
  }, [callback])
}
